import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  NewReleaseSeries,
  NewReleaseTicker,
} from '../../models/new-release-page.types';
import { ByoSubmit } from '../new-release-byo/new-release-byo.component';

@Component({
  selector: 'pla-new-release-hero',
  templateUrl: './new-release-hero.component.html',
  styleUrls: ['./new-release-hero.component.scss'],
})
export class NewReleaseHeroComponent {
  @Input() series!: NewReleaseSeries;
  /** Page H1 on the canonical series route ("26 Number Plates"). */
  @Input() heading: string | null = null;
  @Input() ticker!: NewReleaseTicker;
  @Output() byoSearch = new EventEmitter<ByoSubmit>();

  // Centralised so the template can use it as inline style. Photo positioning
  // anchored to bottom keeps the plate region visible across viewports (handoff §8.4).
  get heroPhotoStyle(): { [k: string]: string } {
    const path = this.series?.heroImagePath || '';
    return {
      'background-image': path ? `url('${path}')` : 'none',
      'background-size': 'cover',
      'background-position': 'center bottom',
    };
  }

  onByoSearch(submission: ByoSubmit): void {
    this.byoSearch.emit(submission);
  }
}
